import { useEffect, useState } from 'react';

const matches = (query) =>
  typeof window !== 'undefined' && Boolean(window.matchMedia) && window.matchMedia(query).matches;

/** CSS medya sorgusu eşleşiyor mu — gizli dalı hiç çizmemek için (CSS `hidden` DOM'u yine üretir) */
export function useMediaQuery(query) {
  const [isMatch, setIsMatch] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const media = window.matchMedia(query);
    const onChange = () => setIsMatch(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return isMatch;
}

/** Tailwind md (768px) ve üzeri mi — mobil/masaüstü dalları için */
export const useMdUp = () => useMediaQuery('(min-width: 768px)');

/** Tailwind sm (640px) ve üzeri mi */
export const useSmUp = () => useMediaQuery('(min-width: 640px)');
